module.exports = __webpack_public_path__ + "img/LittleandLarge-compressor.6ac7db50.jpg";